import { BundleAnalyzerState } from '../models';
var BundleAnalyzer = (function () {
    function BundleAnalyzer() {
    }
    BundleAnalyzer.prototype.analyze = function (group, items, bundles) {
        if (items === void 0) { items = []; }
        if (bundles === void 0) { bundles = []; }
        if (this.someItemsAreNotAvailable(items)) {
            return BundleAnalyzerState.OutOfStock;
        }
        if (items.length === 1 && items[0].sku === group.sku) {
            return this.onlyDirectConnections(bundles) ? BundleAnalyzerState.Ok : BundleAnalyzerState.NoAccessories;
        }
        if (this.onlyOtherAccessories(group, items, bundles) && !this.onlyDirectConnections(bundles)) {
            return BundleAnalyzerState.NoAccessories;
        }
        return this.fitConnections(group, items, bundles) ? BundleAnalyzerState.Ok : BundleAnalyzerState.DoesNotFit;
    };
    BundleAnalyzer.prototype.onlyDirectConnections = function (bundles) {
        var _this = this;
        if (bundles === void 0) { bundles = []; }
        if (bundles.length === 0) {
            return true;
        }
        return bundles.every(function (x) { return _this.isDirectConnection(x); });
    };
    BundleAnalyzer.prototype.isDirectConnection = function (bundle) {
        return bundle.bundles.some(function (x) { return x.bundle.length === 0; });
    };
    BundleAnalyzer.prototype.isOtherAccessory = function (item, bundle) {
        return bundle.bundles.every(function (x) { return x.bundle.every(function (y) { return y.sku !== item.sku; }); });
    };
    BundleAnalyzer.prototype.onlyOtherAccessories = function (group, items, bundles) {
        var onlyAccessories = true;
        for (var _i = 0, items_1 = items; _i < items_1.length; _i++) {
            var item = items_1[_i];
            if (item.sku === group.sku) {
                continue;
            }
            for (var _a = 0, bundles_1 = bundles; _a < bundles_1.length; _a++) {
                var bundle = bundles_1[_a];
                onlyAccessories = onlyAccessories && this.isOtherAccessory(item, bundle);
            }
        }
        return onlyAccessories;
    };
    BundleAnalyzer.prototype.fitConnections = function (group, items, bundles) {
        if (items === void 0) { items = []; }
        if (bundles === void 0) { bundles = []; }
        var fit = true;
        var _loop_1 = function (item) {
            if (item.sku === group.sku) {
                return "continue";
            }
            for (var _i = 0, bundles_2 = bundles; _i < bundles_2.length; _i++) {
                var solutionBundle = bundles_2[_i];
                if (this_1.isDirectConnection(solutionBundle)) {
                    continue;
                }
                if (this_1.isOtherAccessory(item, solutionBundle)) {
                    continue;
                }
                fit =
                    fit &&
                        solutionBundle.bundles.some(function (x) { return x.bundle.some(function (y) { return y.sku === item.sku; }); });
                if (!fit) {
                    break;
                }
            }
        };
        var this_1 = this;
        for (var _i = 0, items_2 = items; _i < items_2.length; _i++) {
            var item = items_2[_i];
            _loop_1(item);
        }
        return fit;
    };
    BundleAnalyzer.prototype.someItemsAreNotAvailable = function (items) {
        return items.some(function (x) { var _a; return ((_a = x.price) === null || _a === void 0 ? void 0 : _a.availabilityState) >= 3; });
    };
    BundleAnalyzer.$inject = [];
    return BundleAnalyzer;
}());
export { BundleAnalyzer };
